import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  appointments: JSON.parse(localStorage.getItem("appointments")) || [], // Persisted data
};

const appointmentSlice = createSlice({
  name: "appointments",
  initialState,
  reducers: {
    setAppointments(state, action) {
      state.appointments = action.payload;
      localStorage.setItem("appointments", JSON.stringify(action.payload)); // Save to localStorage
    },
    updateAppointment(state, action) {
      state.appointments = state.appointments.map(appointment =>
        appointment.AppointmentID === action.payload.AppointmentID
          ? { ...appointment, ...action.payload }
          : appointment
      );
      localStorage.setItem("appointments", JSON.stringify(state.appointments));
    },
    clearAppointments(state) {
      state.appointments = [];
      localStorage.removeItem("appointments");
    },
  },
});

export const { setAppointments, updateAppointment, clearAppointments } = appointmentSlice.actions;
export default appointmentSlice.reducer;
